export default "__VITE_ASSET__DBoORUVi__"